import { SubBenefit } from './sub-benefit.model';

export class PACIBenefit{
    mainBenefitId: number;
    mainBenefitDescription: string;
    subBenefitList: Array<SubBenefit>;
    
}